import { Tabs } from "antd";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { ManagementTeamPageHeading } from "./ManagementTeamPageHeading";
import { ManagementTeamPageContent } from "./ManagementTeamPageContent";
import { ManagementNextPage } from "./NextPage";

export const ManagementTeam = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();
  const items = [
   
    {
      label: "Page Heading",
      key: "managementTeamPageHeading",
      children: <ManagementTeamPageHeading/>
    },
     {
      label: "Page Content",
      key: "managementTeamPageContent",
      children: <ManagementTeamPageContent/>
    },
   {
        label: "Next Page",
        key: "managementNextPage",
        children: <ManagementNextPage />,
      },
  ];

  return (
    <>
      <Tabs
        activeKey={query?.get("subActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get('activeTab')}&subActiveTab=${activeKey}`);
        }}
      ></Tabs>
    </>
  );
};
